
import {sampleColors} from "../utils/colors";
import {toRGB} from "../utils/colorUtils";



const useStockChart = ()=>{

     const createPlot = ({data, plotIndex=0, percentScale=false, postfix='', legendProps})=> {
         return {
             plot: plotIndex,
             data: data,
             yScale: percentScale ? 'percent' : '',
             yLabelPostfix: postfix,
             legend: legendProps
         }
     }


    const formatChartTimeseriesWithSharedIndex = ({
                                                      timestamps, seriesArrays, labels,
                                                      type = 'line',
                                                      opacity=1
    })=>{
        const chartData = [];
        console.log(seriesArrays)
        if (Array.from(seriesArrays).some(x=>x.length !== timestamps.length)){
            throw new Error('All series must have the same length');
        }
        const colorSeries = sampleColors(seriesArrays.length);
        const rgbColors = Array.from(colorSeries).map(x=>toRGB(x, opacity));
        seriesArrays.forEach((x, i)=>{
            const series = x.map((y, index)=>[timestamps[index], y]);
            chartData.push({
                name: labels?.[i] ?? `Series ${i}`,
                data: series,
                type: type,
                stroke: rgbColors[i]
            })
        });
        return chartData
    }

    return {
        formatChartTimeseriesWithSharedIndex,
        createPlot
    }
}

export default useStockChart;